import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { RiFileList3Line, RiFileAddLine } from "react-icons/ri";
import {
  MdOutlineKeyboardArrowRight,
  MdDashboard,
  MdPerson,
} from "react-icons/md";
import { motion, AnimatePresence } from "framer-motion";
import useAuth from "../useAuth";

export default function NavBar() {
  const { user } = useAuth();
  const navigate = useNavigate();

  console.log(user);

  return (
    <div className="w-full min-h-screen bg-gradient-to-b from-slate-900 via-gray-800 to-slate-950 text-white flex flex-col p-4">
      {/* Logo */}
      <div className="flex items-center justify-center mb-8">
        <img
          src="/assets/logo.png"
          alt="logo"
          className="w-36 h-36 rounded-xl"
        />
      </div>

      {/* Main Routes */}
      <Route
        name="Dashboard"
        icon={null}
        onClick={() => navigate("/my/home")}
        urlPath="home"
      />

      {/* Sections */}
      <Section title="Projects">
        <Route
          name="Register Project"
          onClick={() => navigate("/my/registerProject")}
          urlPath="registerProject"
        />
        <Route
          name="Projects List"
          onClick={() => navigate("/my/projectsList")}
          urlPath="projectsList"
        />
      </Section>

      {/* Sections */}
      {user.userType === "admin" && (
        <Section title="Domains">
          <Route
            name="Register Domain"
            onClick={() => navigate("/my/registerDomain")}
            urlPath="registerDomain"
          />
          <Route
            name="Domains List"
            onClick={() => navigate("/my/domainsList")}
            urlPath="domainsList"
          />
        </Section>
      )}

      {/* Employees */}
      <Section title="Employees">
        <Route
          name="Register Employee"
          onClick={() => navigate("/my/registerEmployee")}
          urlPath="registerProject"
          disabled
        />
        <Route
          name="Employees List"
          onClick={() => navigate("/my/employeesList")}
          urlPath="projectsList"
          disabled
        />
      </Section>

      <Section title="Documentations">
        <Route
          name="Add New Doc"
          icon={<RiFileAddLine />}
          onClick={() => navigate("/my/addNewDoc")}
          urlPath="addNewDoc"
          disabled
        />
        <Route
          name="Documents"
          icon={<RiFileList3Line />}
          onClick={() => navigate("/my/docsList")}
          urlPath="docsList"
          disabled
        />
      </Section>

      <Section title="User Profile">
        <Route
          name="Profile"
          icon={<MdPerson />}
          onClick={() => navigate("/my/profile")}
          urlPath="profile"
        />
      </Section>
    </div>
  );
}

// Section with Framer Motion animation
const Section = ({ title, children }) => {
  const [open, setOpen] = useState(true);

  return (
    <div className="mt-4">
      <div
        className="flex items-center justify-between cursor-pointer p-2 hover:bg-[#2c2f36] rounded-md"
        onClick={() => setOpen(!open)}
      >
        <span className="text-xs font-semibold uppercase tracking-wide text-gray-400">
          {title}
        </span>
        <MdOutlineKeyboardArrowRight
          className={`transition-transform duration-300 text-gray-400 ${
            open ? "rotate-90" : "rotate-0"
          }`}
        />
      </div>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.25, ease: "easeInOut" }}
            className="overflow-hidden mt-1 ml-2 border-l border-gray-700"
          >
            <div className="flex flex-col">{children}</div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

// Individual route button
const Route = ({
  name,
  icon = <MdDashboard />,
  onClick,
  urlPath,
  disabled = false,
}) => {
  const location = useLocation();
  const active = location.pathname.includes(urlPath);

  return (
    <div
      onClick={() => {
        if (!disabled && onClick) onClick();
      }}
      className={`flex items-center gap-3 p-2 pl-4 text-sm rounded-md transition-colors duration-200
        ${disabled ? "cursor-not-allowed opacity-50" : "cursor-pointer"}
        ${active && !disabled ? "bg-gray-700 text-white" : "hover:bg-gray-600"}
      `}
    >
      <div
        className={`text-lg ${
          active && !disabled
            ? "text-white"
            : disabled
            ? "text-gray-400"
            : "text-gray-400 group-hover:text-gray-200"
        }`}
      >
        {icon}
      </div>
      <span
        className={`flex-1 ${
          active && !disabled
            ? "text-white"
            : disabled
            ? "text-gray-400"
            : "text-gray-300"
        }`}
      >
        {name}
      </span>
    </div>
  );
};
